// ------------------------------
// モーダル開閉のスクリプト
// ------------------------------
const mainFeatureModal = document.querySelector(".main-feature-modal");
if (mainFeatureModal) {
  const body = document.body; // bodyタグの取得

  // モーダルを開くボタンの要素とモーダルウインドウを動的に取得し、イベントを設定
  const mainFeatureOpenModalButtons = document.querySelectorAll("[class^='js-main-feature-modal-open']");
  const mainFeatureModals = Array.from(document.querySelectorAll("[id^='js-modal-main-feature']"));

  mainFeatureOpenModalButtons.forEach((button, index) => {
    const modal = mainFeatureModals[index]; // 修正
    if (!modal) return;

    button.addEventListener("click", function (e) {
      e.preventDefault();
      modal.showModal();
      modal.classList.add("is-open");
      body.classList.add("is-fixed"); // モーダルを開いたときにbodyにis-fixedクラスを追加
    });

    // モーダル以外で閉じるイベント
    modal.addEventListener("click", function (event) {
      const modalBody = modal.querySelector(".main-feature-modal-body");
      if (!event.target.closest(".main-feature-modal-body")) {
        modal.close();
        modal.classList.remove("is-open");
        body.classList.remove("is-fixed");
      }
    });
  });

  // 共通の閉じるボタンの処理
  const closeModalButtons = document.querySelectorAll(".js-main-feature-modal-close");
  closeModalButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      // すべてのモーダルを閉じる
      mainFeatureModals.forEach((modal) => {
        modal.close();
        modal.classList.remove("is-open");
      });
      body.classList.remove("is-fixed"); // 閉じるボタンを押したときにbodyからis-fixedクラスを削除
    });
  });
}
